export const radius = {
  size1: '0.115rem',
  size2: '0.25rem',
  size3: '0.5rem',
  size4: '1rem',
  rounded: '9999px',
};

export const widths = {
  size1: '1px',
  size2: '2px',
};
